module.exports = {"name":"profile","menu":{"label":"Perfil","route":"/perfil","parent":"menuGeneral","weight":2},"routes":{"path":"/perfil","name":"profile","meta":{"requiresAuth":true}}}


//////////////////
// WEBPACK FOOTER
// ./_source/javascripts/modules/profile/config.json
// module id = 391
// module chunks = 0